<template>
  <div :class="!ativoComp ? 'ui-input inativo' : destaque ? 'ui-input destaque' : 'ui-input'">
    <img v-if="icone" class="icone" :src="require(`@/assets/vivo-consulta/icones/${icone}`)" />
    <label>{{ label }}</label>

    <input
      v-if="mascara"
      :style="icone ? 'padding-left: 35px' : 'padding-left: 15px'"
      :class="destaque ? 'roxo' : ''"
      :placeholder="placeholder"
      autocomplete="new-password"
      :maxlength="tamanhoMax"
      v-mask="mascara"
      :masked="temMascara"
      type="text"
      v-model="valor"
    />

    <input
      v-else
      :style="icone ? 'padding-left: 35px' : 'padding-left: 15px'"
      :class="destaque ? 'roxo' : ''"
      :placeholder="placeholder"
      autocomplete="new-password"
      :maxlength="tamanhoMax"
      :masked="temMascara"
      type="text"
      v-model="valor"
    />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'UiInput',

  directives: {
    mask,
  },

  props: {
    ativo: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Placeholder',
    },
    icone: {
      type: String,
    },
    tamanhoMax: {
      type: Number,
    },
    mascara: {
      // type: String
    },
    temMask: {
      type: Boolean,
      default: false,
    },
    destaque: {
      type: Boolean,
    },
  },

  data() {
    return {
      valor: '',
    };
  },

  computed: {
    ativoComp() {
      return this.ativo;
    },
    temMascara() {
      return !!this.mascara;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.ui-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  border-radius: 5px;
  border: 1px solid $cor_cinza_medium;
  height: 40px;
  width: 100%;

  & .icone {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 10px;
    max-width: 15px;
    height: auto;
    opacity: 0.5;
  }

  & label {
    position: absolute;
    top: 0;
    left: 10px;
    transform: translate(0, -60%);
    font-size: 10px;
    padding: 0 5px;
    color: $cor_cinza_dark;
    background: white;
  }

  & input {
      font-family: 'VivoType';
    background: transparent;
    color: $cor_cinza_dark;
    font-weight: bold;
    font-size: 15px;
    line-height: 40px;
    border-radius: 5px;
    width: 100%;
    outline: none;
    border: 0px;
    transition: all 0.2s ease-in-out;

    &:hover {
      box-shadow: inset 0px 0px 5px rgba(102, 0, 153, 0.25);
    }

    &:focus {
      color: $cor_roxo;
      border: 1px solid $cor_roxo;
      // box-shadow: inset 0px 0px 5px rgba(102, 0, 153, 0.25);
    }

    &::placeholder {
      color: $cor_cinza_medium;
      font-weight: 400;
    }
  }

  & .roxo {
    font-weight: bold;
    color: $cor_roxo;
  }
}

.inativo {
  border: 1px solid $cor_cinza_light;
  background: $cor_cinza_light;

  & img {
    filter: brightness(1) grayscale(1) invert(1);
  }

  & span {
    cursor: default !important;
    color: $cor_cinza_medium !important;
  }

  &:hover {
    background: $cor_cinza_light !important;
  }
}

.destaque {
  border: 1px solid $cor_roxo;
  box-shadow: inset 0px 0px 10px rgba(102, 0, 153, 0.25);
}
</style>
